import { forwardRef } from "react";

import { Anchor, LoadingSpinner } from "@newsela/angelou";
import PropTypes from "prop-types";
import {
  actionPrefixes,
  objectTypes,
  withTrackEvent,
  actionNames,
} from "@newsela/snitch";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import {
  anchorCss,
  containerCss,
  detailsCss,
  instructionsHeaderCss,
  instructionsTextCss,
  titleCss,
} from "./AssignmentInstructions.style";

const propTypes = {
  assignmentData: PropTypes.object,
  assignmentsLoading: PropTypes.bool,
  currentLevelId: PropTypes.string,
};

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const AssignmentInstructions = forwardRef(
  ({ assignmentData, assignmentsLoading, currentLevelId }, ref) => {
    if (assignmentsLoading) {
      return <LoadingSpinner />;
    }

    const assignmentUrl = `${MONOLITH_ORIGIN}/assignment/${assignmentData.content_id}`;

    const eventProperties = {
      objectType: objectTypes.assignment,
      actionPrefix: actionPrefixes.initiate,
      actionName: actionNames.navigate,
      streamProperties: {
        content_type: "Article",
        description: "Navigate to an assignment.",
        content_id: currentLevelId,
        object_id: assignmentData?.assignment_id,
      },
    };

    const hasClassrooms = assignmentData.assignment_classrooms?.length > 0;
    return (
      <div css={containerCss}>
        <h3 css={titleCss}>{assignmentData.title}</h3>
        <ul role="list" css={detailsCss}>
          <li>Teacher: {assignmentData.created_by?.user?.display_name}</li>
          {hasClassrooms ? (
            <li>
              Class: {assignmentData.assignment_classrooms[0].classroom.name}
            </li>
          ) : null}
        </ul>
        <AnchorWithTrackEvent
          __cssFor={{
            root: anchorCss,
          }}
          href={assignmentUrl}
          ref={ref}
          {...eventProperties}
        >
          View assignment
        </AnchorWithTrackEvent>
        <h4 css={instructionsHeaderCss}>Instructions</h4>
        <p
          css={instructionsTextCss}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: assignmentData.instructions || "",
          }}
        />
      </div>
    );
  },
);

AssignmentInstructions.propTypes = propTypes;

export default AssignmentInstructions;
